import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <div className="footer">
            <div className="footer-container">
                    <div>© Copyright 2024 David Schreiber</div>
                    <div className="footer-menu">
                        <Link to="/legal/privacy">
                            Privacy Policy
                        </Link>
                    </div>
            </div>            
        </div>
    );
}